import PropTypes from 'prop-types';
import React from 'react';
import EditorReadOnly from '../../../../../common/EditorPlus/EditorReadOnly.container';

import CommentUserBanner from '../../../../../UserBanner/CommentUserBanner/CommentUserBanner.container';

import styles from './style';

import Reactions from '../../../../../Reactions/Reactions.container';

import CreateComment from '../CreateComment/CreateComment.container';

class Comment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      updateToggle: false,
      replyToCommentId: '',
    };

    this.handleHeightChange = this.handleHeightChange.bind(this);
    this.handleReply = this.handleReply.bind(this);
  }

  handleHeightChange() {
    this.props.onHeightChange();
  }

  handleReply(commentId) {
    if (this.props.onReply) {
      return this.props.onReply(commentId);
    }
    if (this.state.replyToCommentId === commentId) {
      this.setState({
        replyToCommentId: null,
      });
    } else {
      this.setState({
        replyToCommentId: commentId,
      });
    }
  }

  renderCreateComment() {
    if (this.state.replyToCommentId) {
      return (
        <div style={styles.commentCreateWrapper}>
          <CreateComment
            postId={this.props.postId}
            parent={this.state.replyToCommentId}
            root={this.props.rootCommentId}
            key={this.state.replyToCommentId}
            autoFocus
            didComment={() => this.handleReply(this.state.replyToCommentId)}
            style={styles.createComment}
          />
        </div>
      );
    }
  }

  render() {
    const {
      comment,
      style,
      postId,
      sequenceId,
      showComments,
      toggleReaction,
      rootCommentId,
      renderBorder,
      ReplyContainer,
      isReadOnlyUser,
    } = this.props;

    if (!comment) {
      return null;
    }

    return (
      <div
        style={{
          ...styles.commentContainer,
          ...style,
        }}
        key={comment.id}
      >
        <CommentUserBanner
          sequenceId={sequenceId}
          postId={postId}
          style={styles.headerWrapper}
          comment={comment}
          user={comment.user}
          isEdited={!!comment.editedAt}
          handleReply={() => this.handleReply(comment.id)}
        />

        <div style={styles.contentContainer}>
          <div style={styles.editor}>
            <EditorReadOnly
              rawEditorState={JSON.parse(comment.content)}
              onHeightChange={this.handleHeightChange}
              uniqueId={comment.id}
              cell
            />
          </div>
        </div>
        {!isReadOnlyUser && (
          <div style={styles.reactionsWrapper}>
            <Reactions
              sequenceId={sequenceId}
              itemId={comment.id}
              toggleReaction={(e) =>
                toggleReaction({ ...e, commentId: comment.id })
              }
            />
          </div>
        )}
        {!comment.root && (
          <ReplyContainer
            postId={postId}
            ref={(r) => {
              this.commentList = r;
            }}
            comments={comment.replies}
            commentsCount={comment.replies.length}
            totalCommentsCount={comment.replies.length}
            showComments={showComments}
            toggleReaction={toggleReaction}
            rootCommentId={rootCommentId}
            onReply={this.handleReply}
            showInitialComments
            isReply
          />
        )}
        {!isReadOnlyUser && this.renderCreateComment()}
        {renderBorder && (
          <div style={{ padding: '5px 0 0 15px' }}>
            <hr style={styles.commentDelimiter} />
          </div>
        )}
      </div>
    );
  }
}

Comment.propTypes = {
  comment: PropTypes.object.isRequired,
  onHeightChange: PropTypes.func,
  propStyle: PropTypes.object,
  postId: PropTypes.string,
  sequenceId: PropTypes.string,
  isReadOnlyUser: PropTypes.isRequired,
};

export default Comment;
